import { createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-312ed9de")

_pushScopeId("data-v-312ed9de")
const _hoisted_1 = {
  class: "card col-md-12",
  style: {"border-style":"none"}
}
const _hoisted_2 = {
  class: "card-body col-md-12 overflow-auto",
  style: {"height":"300px","overflow-y":"scroll"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("b", null, "Detalles Solicitud")
], -1)
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table table-hover table-borderless" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createVNode("th", null, "ID"),
    /*#__PURE__*/_createVNode("th", null, "Beneficiario"),
    /*#__PURE__*/_createVNode("th", null, "Solicitante"),
    /*#__PURE__*/_createVNode("th", null, "Importe")
  ])
], -1)
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  class: "card-footer",
  id: "comentariosEnviar",
  style: {"background-color":"white"}
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-location-arrow" }, null, -1)
const _hoisted_10 = { class: "fw-bold" }
const _hoisted_11 = {
  class: "fw-normal",
  style: {"color":"#1d2668"}
}
const _hoisted_12 = {
  class: "col-md-12",
  style: {"margin-top":"-0.5rem"}
}
const _hoisted_13 = { style: {"color":"#4f4f4f","margin-bottom":"-0.1rem"} }
const _hoisted_14 = { style: {"color":"#828282"} }
const _hoisted_15 = /*#__PURE__*/_createVNode("hr", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("table", _hoisted_5, [
          _hoisted_6,
          _createVNode("tbody", null, [
            _createVNode("tr", _hoisted_7, [
              _createVNode("td", null, _toDisplayString(_ctx.requisicion.requisicionPagoId), 1),
              _createVNode("td", null, _toDisplayString(_ctx.requisicion.nombreBeneficiario), 1),
              _createVNode("td", null, _toDisplayString(_ctx.requisicion.usuarioSolicitante), 1),
              _createVNode("td", null, _toDisplayString("$" + _ctx.formatearImporte(_ctx.requisicion.importe)), 1)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _withDirectives(_createVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.comentario = $event)),
          class: "form-control area-respuesta",
          id: "exampleFormControlTextarea1",
          rows: "2.5",
          placeholder: "Escribe un comentario"
        }, null, 512), [
          [_vModelText, _ctx.comentario]
        ]),
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.EnviarComentario()), ["prevent"])),
          class: "btn btn-primary float-end mt-2",
          style: {"color":"white","border-radius":"7px"}
        }, [
          _hoisted_9
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bitacora, (bit) => {
        return (_openBlock(), _createBlock("div", {
          class: "col-md-12",
          name: "comentario",
          key: bit.bitacoraEstatusId
        }, [
          _createVNode("p", _hoisted_10, [
            _createTextVNode(_toDisplayString(bit.usuario != null ? bit.usuario.userName : "Desconocido") + " " + _toDisplayString(bit.rolUsuario) + " ", 1),
            _createVNode("small", _hoisted_11, _toDisplayString(bit.descripcionRespuesta) + " el " + _toDisplayString(bit.fechaPersonalizada), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("p", _hoisted_13, _toDisplayString(bit.observaciones), 1),
            _createVNode("small", _hoisted_14, _toDisplayString(bit.fechaPersonalizada), 1)
          ]),
          _hoisted_15
        ]))
      }), 128))
    ])
  ]))
})